var angular = require('angular');
var _module = angular.module('benoit');
var $ = require('jquery');
var _ = require('lodash');

require('./_styles.scss');
require('../../services/lr-touch');

_module.controller('StickheaderCtrl', [
    '$log',
    '$window',
    '$element',
    '$timeout',

    function StickheaderCtrl($log, $window, $element, $timeout) {
        $log.debug('StickheaderCtrl', this);

        $element = $($element);
        var vm = this;
        vm.model = {
            selected: undefined,
            wrapperDiv: undefined
        };
        vm.events = {
            onClick: scrollToId
        };

        // Lifecycle Hooks
        vm.$onInit = init;
        vm.$onDestroy = destroy;

        // Functions
        function checkIfShouldBeSticky() {
            var scrollPosition = $(window).scrollTop();
            var shadow = $element.find('.shadow');
            var offset = vm.model.wrapperDiv ? vm.model.wrapperDiv.offset().top : $element.offset().top;
            var enabledMinWidth = angular.isDefined(vm.enabledMinWidth) ? vm.enabledMinWidth : 1024;

            if(scrollPosition >= offset && $($window).width() > enabledMinWidth) {
                if(!vm.model.wrapperDiv) {
                    $element.css({
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0
                    });
                    $element.addClass('floating');
                    shadow.addClass('visible');

                    vm.model.wrapperDiv = $('<div />');
                    vm.model.wrapperDiv.height($element.outerHeight());
                    $element.after(vm.model.wrapperDiv);
                    if(_.isFunction(vm.isSticky)) {
                        vm.isSticky();
                    }
                }
            } else {
                if(vm.model.wrapperDiv) {
                    $element.css('position', '');
                    $element.removeClass('floating');
                    shadow.removeClass('visible');
                    vm.model.wrapperDiv.remove();
                    vm.model.wrapperDiv = undefined;
                    if(_.isFunction(vm.isntSticky)) {
                        vm.isntSticky();
                    }
                }
            }
        }

        function checkIfWithinAnchor() {
            if(!vm.links || vm.links.length === 0) return;

            var scrollPosition = $(window).scrollTop() + $element.height();
            var selectedLink = vm.links.filter(function (link) {
                return !(link && link.hide);
            }).reduce(function (result, link) {
                var element = $('#' + link.id);

                if(!(element && element.offset())) return;

                var data = {
                    offset: element.offset().top,
                    id: link.id
                };

                if(scrollPosition >= data.offset && (!result || result.offset < data.offset)) {
                    return data;
                } else {
                    return result;
                }
            }, undefined);

            $timeout(function () {
                vm.model.selected = selectedLink ? selectedLink.id : (vm.defaultSelectedId || undefined);
            }, 10);
        }

        function onScroll() {
            checkIfShouldBeSticky();
            checkIfWithinAnchor();
        }

        function scrollToId(id) {
            var additionalAmt = vm.model.wrapperDiv ? 5 : 20;
            var offset = $('#' + id).offset().top - $element.height() + additionalAmt;

            $('html, body').animate({
                scrollTop: offset
            }, 500);
        }

        function init() {
            angular.element($window).on('scroll', onScroll);
            $timeout(function () { angular.element($window).triggerHandler('scroll'); }, 100);
        }

        function destroy() {
            angular.element($window).off('scroll', onScroll);
        }
    }
]);

_module.component('stickyheader', {
    controller: 'StickheaderCtrl',
    controllerAs: 'vm',
    template: require('./index.html'),
    bindings: {
        links: '<',
        enabledMinWidth: '<',
        defaultSelectedId: '@',
        isSticky: '&?',
        isntSticky: '&?'
    }
});
